/** Shared green shell for guest auth screens. */
export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <main className="bg-bg text-white min-h-screen">
      <div className="p-4 lg:p-6 max-w-xl mx-auto">{children}</div>
    </main>
  )
}
